import { skipToNextDynamicBlock } from '~/shared/utils/skipDynamicBlock';
import Button from '../Button';
import styles from './SkipToNextBlock.module.scss';

export const SkipToNextBlock = () => {
    return (
        <Button
            className={styles.skipButton}
            variant="alternative"
            onClick={() => skipToNextDynamicBlock()}
            tabIndex={0}
        >
            Spring over
        </Button>
    );
};
